import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ProductsModule } from '../products/products.module';
import { SharedModule } from '../shared/shared.module';
import { FilterComponent } from './components/filter/filter.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { ProductsComponent } from './components/products/products.component';
import { TopBannerComponent } from './components/top-banner/top-banner.component';
import { LayoutComponent } from './layout/layout.component';
import { OurStoresRoutingModule } from './our-stores-routing.module';
// import { AgmCoreModule } from '@agm/core';
import { GoogleMapsModule } from '@angular/google-maps';

@NgModule({
  declarations: [LayoutComponent, TopBannerComponent, FilterComponent, ProductsComponent, PaginationComponent],
  imports: [
    CommonModule,
    OurStoresRoutingModule,
    SharedModule,
    ProductsModule,
    NgxSpinnerModule,
    NgxSkeletonLoaderModule,
    GoogleMapsModule
    // AgmCoreModule.forRoot({
    //   apiKey: environment.firebaseConfig.apiKey,
    //   libraries: ['places', 'drawing', 'geometry'],
    // }),
  ],
  exports: [
    PaginationComponent
  ]
})
export class OurStoresModule { }
